module.exports = __webpack_public_path__ + "img/logo.7bc5c31b.png";